import { apiRequest } from 'src/utils/api-request';

import type { ReplaceVideoPartialResponseMetadata } from './replace-video-api-types';

export const replaceVideoApi = (shortcode: string, file: File) =>
  apiRequest<ReplaceVideoPartialResponseMetadata>({
    path: `/uploads/${shortcode}/replace?size=${file.size}`,
    method: 'GET',
  });
